<div fxLayout="row" fxFlex="100">
  <select-with-search
    [appearance]="appearance"
    [items]="segments"
    [disabled]="disabled"
    [required]="required"
    [formControl]="selectValue"
    [fxFlex]="100"
    [returnValueInObject]="true"
    [underlineArchivedItems]="true"
    [archivedLabel]="'SEGMENTS_INPUT.ARCHIVED' | translate"
    [floatLabel]="'SEGMENTS_INPUT.TITLE' | translate"
    [searchLabel]="'SEGMENTS_INPUT.SEARCH_SEGMENTS' | translate"
    [noItemsFoundMessage]="'SEGMENTS_INPUT.SEGMENTS_NOT_FOUND' | translate"
    [errorMessageRequired]="'SEGMENTS_INPUT.ERRORS.SEGMENTS_REQUIRED' | translate"
    fieldDisplayedInMatOption="name"
  >
  </select-with-search>
</div>
